
export class EpsTariff {
    tarif_id: string
    tarif_name: string
    tags: string[]
    number_of_units: string
    unit_price: string
    total_price: string

}